<template>
  <div class="topic-detail">
    <div class="topic-detail-header">
      <img
        class="topic-detail-header-left"
        :src="topic.coverPhoto && topic.coverPhoto.url"
        alt="专题图片"
      />
      <div class="topic-detail-header-right">
        <div class="topic-title">
          <span class="topic-icon">专题</span>
          <span class="topic-title-text">{{ topic.title }}</span>
        </div>
        <div class="topic-content">{{ topic.post || topic.text }}</div>
        <div class="topic-nums">
          <div class="topic-nums-item">
            <span>{{
              (topic.topicArticles && topic.topicArticles.length) || 0
            }}</span>
            <span>篇{{ isArticle }}</span>
          </div>
          <div class="topic-nums-item" style="margin-left: 66px">
            <span>{{ pageview }}</span>
            <span>位观众</span>
          </div>
        </div>
      </div>
    </div>
    <div class="line">
      <span>全部{{ isArticle }}</span
      ><span></span>
    </div>
    <div class="topic-body">
      <div class="topic-body-left" v-if="isArticle === '文章'">
        <post-card
          v-for="item in topic.topicArticles"
          :key="item._id"
          :post="item"
        />
      </div>
      <div class="topic-body-left topic-course" style="" v-else>
        <course-card
          v-for="item in topic.topicArticles"
          :key="item._id"
          :course="item"
        />
      </div>
      <div class="topic-body-right">
        <hot-topic></hot-topic>
      </div>
    </div>
  </div>
</template>

<script>
import PostCard from "@/components/post/PostCard";
import CourseCard from "@/components/course/CourseCard";
import HotTopic from "@/components/common/HotTopic";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "topic-detail",
  components: {
    PostCard,
    HotTopic,
    CourseCard,
  },
  computed: {
    ...mapGetters("topic", ["topic"]),
    pageview() {
      if (!this.topic.topicArticles || !this.topic.topicArticles.length)
        return 0;
      return this.topic.topicArticles
        .map((e) => e.pageview)
        .reduce((total, pv) => total + pv);
    },
    isArticle() {
      const articleType =
        this.topic.topicArticles &&
        this.topic.topicArticles[0] &&
        this.topic.topicArticles[0].articleType;
      return articleType === "0"
        ? "文章"
        : articleType === "1"
        ? "课程"
        : "内容";
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("topic", ["getTopic"]),
  },
  created() {
    this.getTopic({
      id: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss">
.topic-detail {
  padding-top: 40px;
  text-align: left;

  > .topic-detail-header {
    height: 182px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > .topic-detail-header-left {
      width: 404px;
      height: 182px;
      border-radius: 6px;
    }

    > .topic-detail-header-right {
      width: 768px;
      height: 182px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 27px;

      > .topic-title {
        height: 30px;
        display: flex;
        align-items: center;

        > .topic-icon {
          display: inline-block;
          line-height: 24px;
          text-align: center;
          width: 66px;
          background: #e70012;
          border-radius: 2px;
          color: #ffffff;
          font-weight: bold;
        }

        > .topic-title-text {
          margin-left: 14px;
          font-size: 24px;
          line-height: 24px;
          font-weight: bold;
          color: #333333;
        }
      }

      > .topic-content {
        font-size: 14px;
        color: #999999;
        text-align: left;
        line-height: 24px;
      }

      > .topic-nums {
        display: flex;

        > .topic-nums-item {
          display: flex;
          flex-direction: column;
          text-align: center;

          & > :first-child {
            color: #feb705;
            font-size: 40px;
            font-weight: bold;
          }

          & > :nth-child(2) {
            color: #333333;
            font-size: 14px;
          }
        }
      }
    }
  }

  > .line {
    margin: 40px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #333333;

    > :nth-child(2) {
      display: inline-block;
      width: calc(100% - 80px);
      border-top: 1px solid #eaeaea;
    }
  }

  > .topic-body {
    display: flex;
    justify-content: space-between;

    > .topic-course {
      padding-top: 23px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 850px;

      > div {
        margin-bottom: 23px;
      }
    }
  }
}
</style>